import type { Article } from '@/types'

import { scoreText, tokenize } from '@/lib/search'
import { PERSON_BY_SLUG } from '@/constants/people'

import {
    CATEGORY_BY_SLUG,
    TYPE_BY_KEY,
    UNIT_BY_KEY,
    labelTitle,
    subcategoryTitle
} from '@/constants/taxonomy'

const searchFields = (article: Article) => ({
    title: article.title,
    summary: [article.summary, ...(article.lesson ? Object.values(article.lesson) : [])].join(' '),
    labels: article.labels.map(key => `${labelTitle(key)} ${key}`).join(' '),
    meta: [
        CATEGORY_BY_SLUG[article.category]?.title,
        subcategoryTitle(article.category, article.subcategory),
        TYPE_BY_KEY[article.type]?.title,
        UNIT_BY_KEY[article.unit]?.title,
        PERSON_BY_SLUG[article.author]?.name
    ].join(' ')
})

export type RankedArticle = {
    article: Article
    score: number
}

/** Scores every article against the query (all words must match). An empty query keeps every article with score 0. */
export const rankArticles = (articles: Article[], query: string): RankedArticle[] => {
    const tokens = tokenize(query)

    if (!tokens.length) return articles.map(article => ({ article, score: 0 }))

    return articles
        .map(article => ({ article, score: scoreText(searchFields(article), tokens) }))
        .filter(item => item.score > 0)
        .sort((a, b) => b.score - a.score || b.article.views - a.article.views)
}
